module.exports = __webpack_public_path__ + "static/media/tibet.3f00c818.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tibet.svg
// module id = 782
// module chunks = 0